"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TextFieldSuffix;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

TextFieldSuffix.propTypes = {
  suffixRef: _propTypes.func
};

function TextFieldSuffix(props) {
  return _react2.default.createElement("span", {
    className: "mdc-text-field__suffix",
    ref: function ref(_ref) {
      props.suffixRef(_ref);
    }
  }, _react2.default.createElement("span", {
    className: "mdc-text-field__suffix__content",
    style: {
      marginLeft: "-" + props.suffixWidth + "px"
    }
  }, props.children));
}